export default __webpack_public_path__ + "static/media/mostra-3.7af56495.png";